import { render, staticRenderFns } from "./CollectedPage.vue?vue&type=template&id=3a96807a&scoped=true&lang=html&"
import script from "./CollectedPage.vue?vue&type=script&lang=js&"
export * from "./CollectedPage.vue?vue&type=script&lang=js&"
import style0 from "./CollectedPage.vue?vue&type=style&index=0&id=3a96807a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96807a",
  null
  
)

export default component.exports